import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TuiLike } from '@taiga-ui/kit';
import { TranslateModule } from '@ngx-translate/core';

import { ThemeSwitcherComponent, ThemeSwitcherMiniComponent } from './components';

@NgModule({
  declarations: [ThemeSwitcherComponent, ThemeSwitcherMiniComponent],
  imports: [CommonModule, FormsModule, TuiLike, TranslateModule],
  exports: [ThemeSwitcherComponent, ThemeSwitcherMiniComponent],
})
export class ThemeSwitcherModule {}
